import { Route, Routes } from "react-router-dom"

import { RoadwayMapLayersRouter } from "../../../modules/roadway/routers/RoadwayMapLayersRouter"
import { RoadworksMapLayersRouter } from "../../../modules/roadworks/routers/RoadworksMapLayersRouter"
import { MODULE_ROADWAY, MODULE_ROADWORKS } from "../../constants/modules"

export const RoadMapRouter = () => {

    return (
        <Routes>
            <Route
                element={<RoadwayMapLayersRouter />}
                path={`/${MODULE_ROADWAY}/*`}
            />
            <Route
                element={<RoadworksMapLayersRouter />}
                path={`/${MODULE_ROADWORKS}/*`}
            />
        </Routes>
    )
}
